// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 442 ? "bf99be8e" : chunkId) + "." + {"128":"3d1ab2386b86b3ae","324":"d96a80ac254f7b0f","442":"d27b63a208827873","596":"3d1ab2386b86b3ae","615":"d96a80ac254f7b0f"}[chunkId] + ".js";
};